export const engineTypes: Array<string> = [
    'Electric',
    'HybridPetrol',
    'Diesel',
    'Petrol',
    'Gas',
];
